import { combineLatest, Observable, of } from 'rxjs'
import { filter, map, take } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'

import { Component, Input, OnInit } from '@angular/core'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { Store } from '@ngrx/store'

import { participationActions } from '../../booking/participation/participation.actions'
import { participationSelectors } from '../../booking/participation/participation.selectors'
import {
  ProductGroup,
  ProductGroupType
} from '../../product/product-group/product-group'
import { productGroupActions } from '../../product/product-group/product-group.actions'
import { productGroupSelectors } from '../../product/product-group/product-group.selectors'
import { productActions } from '../../product/product.actions'
import { productSelectors } from '../../product/product.selectors'
import { saleSelectors } from '../sale.selectors'

@Component({
  selector: 'sale-organize-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SaleOrganizeTabComponent implements OnInit {
  @Input() public saleId: number

  public isLoading$: Observable<boolean>
  public saleId$: Observable<number>
  public productGroups$: Observable<ProductGroup[]>

  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.store.dispatch(
      productGroupActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: { type: ProductGroupType.PURCHASEABLE_SET },
          join: [
            { field: 'products' },
            { field: 'products.parentBookableProducts' }
          ]
        })
      })
    )

    this.store.dispatch(
      productActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            bookable: false
          }
        })
      })
    )

    this.isLoading$ = combineLatest([
      this.store.select(participationSelectors.selectIsLoading),
      this.store.select(productSelectors.selectIsLoading),
      this.store.select(productGroupSelectors.selectIsLoading)
    ]).pipe(
      map(
        ([isLoadingParticipations, isProdutLoading, isProductGroupsLoading]) =>
          isLoadingParticipations || isProdutLoading || isProductGroupsLoading
      )
    )

    this.saleId$ = this.saleId
      ? of(this.saleId)
      : this.store
          .select(saleSelectors.selectIdRouteParam)
          .pipe(filter((id) => Boolean(id)))

    this.saleId$.pipe(take(1)).subscribe((saleId) => {
      this.store.dispatch(
        participationActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: { 'saleItem.saleId': saleId },
            join: [
              { field: 'saleItem' },
              { field: 'organization' },
              { field: 'booking' },
              { field: 'booking.product' },
              { field: 'booking.linkedProduct' }
            ]
          })
        })
      )
    })

    this.productGroups$ = this.store
      .select(productGroupSelectors.selectAll)
      .pipe(
        map((productGroups) => {
          return productGroups.filter(
            (productGroup) =>
              productGroup.type == ProductGroupType.PURCHASEABLE_SET &&
              productGroup.products?.length > 0
          )
        })
      )
  }
}
